import { api } from './client';

/**
 * Endpoints reservados del OWNER (F2 — tanda cierre). Prefijo: /api/owner.
 * Un ADMIN recibe 403 en todos: estos datos no llegan a su navegador.
 */

export interface SpendLimits {
  enabled: boolean;
  installationDailyCapUsd: number;
  globalDailyCapUsd: number;
}

export type SpendLimitOrigin = 'db' | 'env';

export interface SpendLimitsView {
  efectivos: SpendLimits;
  origen: Record<keyof SpendLimits, SpendLimitOrigin>;
  envDefaults: SpendLimits;
  /** Gasto de HOY en USD (null si no se pudo calcular). */
  gastoHoyUsd: number | null;
  /** A dónde va el aviso de tope: sin teléfonos (y sin apagar) = nadie se entera.
   *  Opcionales: el panel puede subir antes que la API. */
  avisoTope?: AvisoTope;
  /** Modelos usados que la tabla de precios no conoce: su gasto no cuenta para el tope. */
  modelosSinPrecio?: string[];
}

export interface AvisoTope {
  apagado: boolean;
  telefonos: string[];
}

export const putAvisoTope = (owner_phone: string) =>
  api.put<AvisoTope>('/api/owner/aviso-tope', { owner_phone });

export const getSpendLimits = () => api.get<SpendLimitsView>('/api/owner/spend-limits');

export const putSpendLimits = (limites: Partial<SpendLimits>, claveOperacion: string) =>
  api.put<SpendLimitsView>('/api/owner/spend-limits', { limites, claveOperacion });

export const putConversationQuota = (cupo: number, claveOperacion: string) =>
  api.put<{ cupo: number }>('/api/owner/conversation-quota', { cupo, claveOperacion });

export const getOperationKey = () => api.get<{ definida: boolean }>('/api/owner/operation-key');

export const putOperationKey = (nueva: string, actual?: string) =>
  api.put<{ definida: boolean }>('/api/owner/operation-key', { nueva, actual });
